<template>
    <Toolbar class="mb-4">
        <template v-slot:start>
            <div class="my-2">
                <h5 v-if="userCompanyId && userCompanyId?.name">{{ userCompanyId?.name + ' has been selected' }}</h5>
                <h5 v-else>Select a company before proceeding</h5>
                <load-company :userCompanyId="userCompanyId" :companies="companies" />
            </div>
        </template>
    </Toolbar>
</template>
<script>
import LoadCompany from './company/LoadCompany.vue';
import { mapGetters } from 'vuex';

import { fetchAllCompanies } from '@/services/company-service';

export default {
    name: 'CompanySelect',
    components: { LoadCompany },
    computed: {
        ...mapGetters('auth', ['userCompanyId']),
    },
    data() {
        return {
            companies: null,
        };
    },
    async created() {
        this.companies = await fetchAllCompanies();
    },
};
</script>
